var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497 81h-482c-8.284 0-15 6.716-15 15v182.434c0 8.284 6.716 15 15 15h76.511l118.527 118.528c12.276 12.277 28.6 19.038 45.962 19.038s33.686-6.761 45.962-19.038l118.528-118.528h76.51c8.284 0 15-6.716 15-15v-182.434c0-8.284-6.716-15-15-15zm-156.146 249.645-38.892-38.891c-5.857-5.857-15.355-5.857-21.213 0s-5.858 15.355 0 21.213l38.892 38.891-21.214 21.214-38.891-38.891c-5.857-5.857-15.355-5.857-21.213 0s-5.858 15.355 0 21.213l38.634 38.634c-13.698 10.256-33.26 9.167-45.706-3.279l-122.921-122.922c-2.812-2.813-6.628-4.394-10.606-4.394h-67.724v-152.433h191.085l-78.479 78.475c-9.748 9.747-9.748 25.608 0 35.355 12.672 12.672 29.317 19.008 45.962 19.008 16.646 0 33.291-6.336 45.963-19.008l21.468-21.467 106.068 106.069zm141.146-67.211h-67.723c-3.979 0-7.794 1.58-10.606 4.394l-20.392 20.392-74.278-74.279c15.542-2.197 30.527-9.256 42.455-21.183 5.858-5.857 5.858-15.354 0-21.213-5.856-5.858-15.354-5.858-21.213 0-17.547 17.544-46.095 17.544-63.64 0-5.857-5.857-15.355-5.857-21.213 0l-32.073 32.073c-12.446 12.446-32.012 13.542-45.712 3.283l76.87-76.863c12.277-12.277 28.599-19.038 45.961-19.038h191.564z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.00dfa7a82ec31a15a814ede496f04412.svg";
export { ForwardRef as ReactComponent };